import React, { useMemo } from "react";
import classNames from "classnames";
import { useUser } from "@hooks/useUser";
import { UserSignupPurpose } from "@common/types/user";
import { Button } from "@design-system/Button/Button";
import { LeftArrowIcon } from "@icons";
import { HStack } from "@design-system/HStack/HStack";
import animations from "../layout/OnboardingLayout.module.scss";
import commonStyles from "./common.module.scss";

interface Props {
    onBack(): void;
}

export const WaitlistOutro: React.FC<Props> = ({ onBack }) => {
    const user = useUser();

    const title = useMemo(() => {
        const isAccountant =
            user?.signupPurpose === UserSignupPurpose.ACCOUNTANT;

        if (isAccountant) {
            return "Kick currently only supports businesses that pay taxes in the U.S.";
        }

        return "Kick currently only works with businesses filing U.S. taxes";
    }, [user]);

    return (
        <div className={commonStyles.content420}>
            <header className={classNames(animations.fadeIn2, "text-center")}>
                <h1 className={commonStyles.title}>{title}</h1>

                <p className={commonStyles.subtitle}>
                    We’ll let you know as soon as we launch in your country.
                </p>
            </header>

            <HStack as="footer" gap={12} align="center" justify="center">
                <Button
                    variant="primary"
                    className={animations.fadeIn1}
                    onClick={onBack}
                    size="xl"
                    iconOnly
                    aria-label="Go back"
                >
                    <LeftArrowIcon />
                </Button>
                <Button
                    asChild
                    variant="primary"
                    className={animations.fadeIn1}
                    size="xl"
                >
                    <a
                        href="https://x.com/kickfinance"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Follow us on X
                    </a>
                </Button>
            </HStack>
        </div>
    );
};
